module.exports = __webpack_public_path__ + "static/media/Applicationform.185acd86.pdf";